__turbopack_context__.v({
  "tag": "VdsZ6W_tag",
});
